module.exports = __webpack_public_path__ + "03_hige_gray.45145f30.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer3/03_hige_gray.png
// module id = vPV4
// module chunks = 0